import { render } from "./CommonSection.vue?vue&type=template&id=0a55956d"
import script from "./CommonSection.vue?vue&type=script&lang=js"
export * from "./CommonSection.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./CommonSection.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__